import { render, staticRenderFns } from "./SiChartPie.vue?vue&type=template&id=22334954&scoped=true&lang=html&"
import script from "./SiChartPie.vue?vue&type=script&lang=js&"
export * from "./SiChartPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22334954",
  null
  
)

export default component.exports